export default __webpack_public_path__ + "static/media/gallery-wip-handle-neck_00.2bbc87bf.jpg";